import { ICellRendererParams } from '@ag-grid-community/core';

export function emailFormatter(params: ICellRendererParams): string {
  let val = _.get(params.data, params.colDef.field);
  return val ? `<div class="inner-cell"><a href="mailto:${val}">${val}</a></div>` : '';
}
